import React, { useState, useEffect } from "react";
import axios from "axios";
import { Collapse, Toggle, Table, Alert, Button, Input } from "react-daisyui";
import { IndividualData } from "../../../../interfaces/IndividualReport";
import APIData, { setDefaultAPIData } from "../../../../interfaces/apiData";
import PaginationBar from "../../../../components/PaginationBar";
import HighlightText from "../Hightlight";
import fetchData from "../../../../utils/getAllPaginated";
import { toast } from "react-toastify";

const IndividualFormData = ({ selectedRow, setSelectedRow, showIndiviaulReport, demographic }: any) => {
  const [pageData, setPageData] = useState<APIData>(setDefaultAPIData);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [individualData, setIndividualData] = useState<IndividualData[]>([]);

  //   const [selectedRow, setSelectedRow] = useState<Set<number>>(new Set());
  const [isAllRowSelected, setIsAllRowSelected] = useState<boolean>(false);

  //States for search filters
  const [searchNotFound, setSearchNotFound] = useState(false);
  const [searchTitle, setSearchTitle] = useState("");
  const [searchAssessmentCode, setSearchAssessmentCode] = useState("");

  const fetchIndividualData = () => {
    fetchData('/api/v1/individual-report/', `&target_demo_id=${demographic?.id}`)
    .then((result)=>setIndividualData(result))
    .catch((err)=>{
      toast.error(`Error occured while fetching cohort report options - ${err?.message}`)
    })
  };

  const renderPage = () => {
    const filteredData = individualData
      .filter((data) =>
        data.title.toLowerCase().includes(searchTitle.toLowerCase())
      )
      .filter((data) =>
        data.assessment_code
          .toLowerCase()
          .includes(searchAssessmentCode.toLowerCase())
      );

    filteredData.length === 0
      ? setSearchNotFound(true)
      : setSearchNotFound(false);

    setPageData({
      ...pageData,
      results: filteredData.slice((page - 1) * pageSize, page * pageSize),
      total: filteredData.length,
      current_page: page,
      page_size: pageSize,
    });
  };

  useEffect(() => {
    fetchIndividualData();
  }, []);

  useEffect(() => {
    // Update data when page or pageSize changes
    console.log(individualData);
    renderPage();
  }, [individualData, page, pageSize, searchTitle, searchAssessmentCode]);

  /** Search Filters functions */
  const handleSearchTitleChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchTitle(event.target.value);
    setPage(1);
    setIsAllRowSelected(false);
  };

  const handleSearchAssessmentCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchAssessmentCode(event.target.value);
    setPage(1);
    setIsAllRowSelected(false);
  };
  /** End of Search Filters functions */

  /** Checkboxes functions */
  useEffect(() => {
    // Determine if all checkboxes on the current page are selected
    const allRowSelected = pageData?.results.every((data) =>
      selectedRow.has(data.id)
    );
    console.log(allRowSelected, pageData.results.length);
    if (pageData?.results.length == 0) {
      setIsAllRowSelected(false);
    } else {
      setIsAllRowSelected(allRowSelected);
    }
  }, [pageData, selectedRow]);

  useEffect(() => {
  
  }, [showIndiviaulReport])

  const toggleSelection = (id: number) => {
    const newSelectedRow = new Set(selectedRow);
    console.log("newSelectedRow", newSelectedRow, selectedRow);
    if (selectedRow.has(id)) {
      newSelectedRow.delete(id);
    } else {
      newSelectedRow.add(id);
    }
    setSelectedRow(newSelectedRow);
  };

  const selectAllRow = () => {
    const newSelectedRow = new Set(selectedRow);

    if (isAllRowSelected) {
      // if all rows are selected, deselect all ON CURRENT PAGE
      for (const data of pageData?.results) {
        newSelectedRow.delete(data.id);
      }
    } else {
      // if not all rows are selected, select all ON CURRENT PAGE
      for (const data of pageData?.results) {
        newSelectedRow.add(data.id);
      }
    }
    setSelectedRow(newSelectedRow);
  };

  const selectAll = () => {
    const newSelectedRow: Set<number> = new Set();
    individualData?.forEach((data) => newSelectedRow.add(data.id));
    setSelectedRow(newSelectedRow);
  };

  const DeselectAll = () => {
    setSelectedRow(new Set());
  };
  /** End of Checkboxes functions */

  // Change the current page of the paginated data
  function changePage(pageNum: number) {
    setPage(pageNum);
    renderPage();
  }

  function changePageSize(size: number) {
    const totalPages = Math.ceil(pageData?.total / size);

    // If the current page is greater than the total pages calculated by the new page size,
    // reset the page to the last available page.
    let newPage = page > totalPages ? totalPages : page;
    setPage(newPage);
    setPageSize(size);
    renderPage();
  }

  return (
    <>
      
     
        <>
          <Alert
            status="info"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="w-6 h-6 mx-2 stroke-current"
                style={{ minWidth: "30px" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            }
          >
            Select which information you would like the automatic individual
            Reflect Report to include.
          </Alert>

          <div className="flex flex-row">
            {/* Search filters */}
            <Input
              id="IndividualFormSearchTitle"
              type="text"
              placeholder="Search by Title"
              value={searchTitle}
              onChange={handleSearchTitleChange}
              className="px-2 py-1 mr-2 text-xs "
            />

            <Input
              type="text"
              id="IndividualFormSearchAssessmentCode"
              placeholder="Search by Assessment Code"
              value={searchAssessmentCode}
              onChange={handleSearchAssessmentCodeChange}
              className="px-2 py-1 text-xs min-w-[180px]"
            />
          </div>

          <div className="flex flex-row">
            <Button id="IndividualFormSelectAllRows" type="button" size="sm" onClick={selectAll} className="mr-2 btn-neutral ">
              Select All
            </Button>

            <Button
              id="IndividualFormDeselectAllRows"
              type="button"
              size="sm"
              onClick={DeselectAll}
              className="mr-2 btn-neutral "
            >
              Deselect All
            </Button>

            {/* <Button
              size="sm"
              onClick={openExportModal}
              className="mb-4 btn-neutral "
            >
              View selected
            </Button> */}

            <div className="my-auto ml-auto  text-xs">
              {selectedRow.size == 0 && (
                <span>0 selected, total: {pageData.total}</span>
              )}
              {selectedRow.size > 0 && (
                <span>
                  {selectedRow.size} selected, total: {pageData.total}
                  {/* {selectedRow.size  > 1 ? "s" : ""} */}
                </span>
              )}
            </div>
          </div>

          {!pageData?.results && (
            <p>
              <i>No Data Found</i>
            </p>
          )}

          {pageData?.results && (
            <>
              <div className="overflow-x-auto">
                <Table id="IndividualFormTable" className="w-full">
                  <Table.Head>
                    <span>
                      <label>
                        <input
                          id="IndividualFormSelectAllRowsCheckbox"
                          type="checkbox"
                          checked={isAllRowSelected}
                          onChange={(e) => {
                            e.stopPropagation();
                            selectAllRow();
                          }}
                          className="w-5 h-5 cursor-pointer"
                        />
                      </label>
                    </span>
                    <span>Title</span>
                    <span>Assessment Code</span>
                  </Table.Head>
                  <Table.Body>
                    {pageData?.results?.map((data: IndividualData) => (
                      <Table.Row
                        key={data.id}
                        hover
                        className="cursor-pointer text-sm p-1"
                      >
                        <input
                          id={`IndividualFormRowCheckbox${data.id}`}
                          type="checkbox"
                          checked={selectedRow?.has(data.id)}
                          onChange={(e) => {
                            e.stopPropagation();
                            toggleSelection(data.id);
                          }}
                          className="w-5 h-5 cursor-pointer"
                        />
                        <HighlightText
                          text={data.title}
                          highlight={searchTitle}
                        />
                        <HighlightText
                          text={data.assessment_code}
                          highlight={searchAssessmentCode}
                        />
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </div>

              {searchNotFound && (
                <p className="m-4">
                  <i>No matching results found.</i>
                </p>
              )}

              <div className="flex justify-between">
                <select
                  id="IndividualFormPaginationSize"
                  value={pageSize}
                  onChange={(e) => changePageSize(parseInt(e.target.value))}
                  className="p-2"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>

                <PaginationBar
                  onChange={changePage}
                  itemCount={pageData.total}
                  currentPage={pageData.current_page}
                  pageSize={pageData.page_size}
                ></PaginationBar>
              </div>
            </>
          )}
        </>
    </>
  );
};

export default IndividualFormData;
